// Initialize your components on DOM Ready.
window.lazySizesConfig = window.lazySizesConfig || {}
window.lazySizesConfig.preloadAfterLoad = true
require('lazysizes');
import AOS from 'aos';
import swupSettings from './swup.js'
import bodyScroll from './bodyScroll.js'
import { gsap } from "gsap/all";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import components from './components'
import loadComponents from 'gia/loadComponents';

import ageGate from './agegate';

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);


(function ($) {
  
  AOS.init();
  swupSettings.init();
  bodyScroll.init();
  ageGate.init();
  
  // loadComponents(components);
  
  $('.modal-overlay , .modal-close').on('click', function (e) {
    e.preventDefault();
    $('.modal').addClass('opacity-0 pointer-events-none')
    $('body').removeClass('modal-active')
  });
  
  $('.modal-open').on('click', function (e) {
    e.preventDefault();
    const m = $(this).data("modal");
    $('#modal-' + m).toggleClass('opacity-0 pointer-events-none')
    $('body').toggleClass('modal-active')
  });
  
  
  
  $(document).on('forminator:form:submit:success', function (formData) {
    
    var form_id = $(formData.target).find('input[name="form_id"]').val();
    
    if (form_id == 276) {
      
      function setCookie(name, value, days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
      }
      
      if ( jQuery('.hustle-ui').is(":visible") ) {
        setCookie('inc_optin_never_see_again-slidein-1', '1', 30);
        jQuery('.hustle-ui').fadeOut('600');
      }
      dataLayer.push({
        'event': 'newsletter_signup'
      });
    }
  });
  
  
  // $('[g-component="StoreLocatorComponent"]').on('click', '.action.directions, .btn-asl.s-direction', function (e) {
  //   e.preventDefault();
  //   console.log('find_product');
  //   dataLayer.push({
  //     'event': 'find_product'
  //   });
  // });
  
})(jQuery);